<template>
	<div class="box">
		<div class="box-title">{{ userInfo.welcomeDesc }}！{{ userInfo.company }}</div>
		<el-row :gutter="20" style="margin-bottom: 20px">
			<el-col :span="15">
				<el-card class="box-card">
					<div slot="header" class="flex">
						<span class="box_title">账户总览</span>
						<div @click="eye = !eye" class="ele">
							<img class="" v-if="eye" src="../../../assets/images/zh.png" />
							<img class="" v-else src="../../../assets/images/bi.png" />
						</div>
					</div>
					<div style="border-bottom: 1px solid #ebeef5">
						<div class="body_title">可用余额</div>
						<div class="flex body_title">
							<div class="body_title_center">
								<span class="font">{{ eye ? userInfo.amount : ' *** ' }}</span>
								{{ $MONEY_NAME }} （1{{ $MONEY_NAME }} =1元人民币）
							</div>
							<div class="recharge" @click="recharge">充值</div>
							<div class="recharge1" @click="$router.push('/expense')">明细</div>
						</div>
					</div>
					<div class="footers">
						<div>
							<div class="footer_title">订单数</div>

							<div>
								<el-link
									v-if="eye"
									style="vertical-align: bottom"
									class="footer_font"
									type="primary"
									:class="eye ? 'wap_color' : ''"
									@click="orderTo(1)"
									>{{ userInfo.orders }}</el-link
								>
								<span class="footer_font" v-else>***</span>
								个
							</div>
						</div>
						<div>
							<div class="footer_title">优惠券</div>
							<div>
								<el-link
									v-if="eye"
									style="vertical-align: bottom"
									class="footer_font"
									type="primary"
									:class="eye ? 'wap_color' : ''"
									@click="orderTo(2)"
									>{{ userInfo.coupons }}</el-link
								>
								<span class="footer_font" v-else>***</span>
								个
							</div>
						</div>

						<div>
							<div class="footer_title">物流账单</div>
							<div>
								<el-link
									v-if="eye"
									style="vertical-align: bottom"
									class="footer_font"
									type="primary"
									:class="eye ? 'wap_color' : ''"
									@click="LogisticsOrderTo()"
									>{{ userInfo.logistics }}</el-link
								>
								<span class="footer_font" v-else>***</span>
								个
							</div>
						</div>

						<div>
							<div class="footer_title">即将到期资源</div>
							<div>
								<span class="footer_font" :class="eye ? 'red' : ''">{{
									eye ? userInfo.expires : '***'
								}}</span>
								个
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="9">
				<el-card class="box-card">
					<div class="block">
						<el-avatar style="margin: 10px 20px 0 0" :size="60" :src="userInfo.face">
							<img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
						</el-avatar>
						<div>
							<div class="block_name">{{ userInfo.nickname }}</div>
							<div class="block_IP">登录IP：{{ userInfo.lastIp }}</div>
							<div class="block_IP">上次登录时间：{{ userInfo.lastTime }}</div>
						</div>
					</div>
					<div class="block_footer">
						<div>
							<div class="footer_title">子账户数</div>
							<div>{{ userInfo.childAccountNum }}</div>
						</div>
						<div>
							<div class="footer_title">角色</div>
							<div>{{ userInfo.roleNum }}</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<!-- 在用资源 -->
			<el-col :span="15">
				<el-card class="box-card">
					<div slot="header">
						<span class="box_title">在用资源</span>
						<el-link
							style="float: right; color: #003366"
							type="primary"
							@click="$router.push('/yingyong/platform')"
							>更多资源前往马帮应用市场</el-link
						>
					</div>
					<div>
						<el-tabs @tab-click="handleClick">
							<el-tab-pane label="平台资源" name="0">
								<el-card
									:class="{ disable_status: item.mbStatus }"
									style="margin: 10px 0 40px"
									v-for="item in resource"
									:key="item.pacakgeId"
								>
									<div class="tables_center">
										<div class="tables_center_icon"><i class="el-icon-suitcase-1"></i></div>
										<div class="tables_center_flex">
											<div class="fontWeight">
												{{ item.categoryName ? item.categoryName : item.name }}
											</div>
											<div class="tables_center_footer">
												<div class="footer_edition">
													<span>版本：{{ item.name }}</span>
													<span v-if="item.isServer == 1">服务器ID：{{ item.ecsGid }}</span>
													<span>有效期至：{{ item.endDate }}</span>
												</div>
												<div>
													<div class="flex" v-if="!item.mbStatus">
														<div
															class="recharge"
															@click="toProduct(item.moduleId, item.editionId)"
															v-if="item.isRenew == 1"
														>
															续费
														</div>
														<div
															class="recharge"
															@click="toProduct(item.moduleId, item.editionId)"
															v-if="item.isBuy == 1"
														>
															加购
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="tables_footer">
										<div v-if="Object.keys(item.surplus.byDay).length > 1">
											<div class="tables_footer_font">
												截止{{ item.surplus.byDay.updateTime }} 统计
											</div>
											<div class="footer">
												<div v-if="item.surplus.byDay.orderCnt">
													<div class="footer_title">剩余单量(可用)</div>
													<div>
														<span class="footer_font">
															{{ item.surplus.byDay.orderCnt }}
														</span>
														{{ Boolean(Number(item.surplus.byDay.orderCnt)) ? '个' : '' }}
														<el-link
															v-if="flag && !item.mbStatus"
															style="font-size: 12px; color: #003366"
															type="primary"
															@click="$router.push('/deduction')"
														>
															扣单明细
														</el-link>
													</div>
												</div>
												<div v-if="item.surplus.byDay.isWms">
													<div class="footer_title">启用wms(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byDay.isWms == 1 ? '是' : '否'
														}}</span>
													</div>
												</div>
												<div v-if="item.surplus.byDay.private">
													<div class="footer_title">启用私有云(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byDay.private == 1 ? '是' : '否'
														}}</span>
													</div>
												</div>
											</div>
										</div>
										<div v-if="Object.keys(item.surplus.byTime).length > 1">
											<div class="tables_footer_font">
												截止{{ item.surplus.byTime.updateTime }} 统计
											</div>
											<div class="footer">
												<div v-if="item.surplus.byTime.development_product">
													<div class="footer_title">开发商品数(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.development_product
														}}</span>
														{{
															Boolean(Number(item.surplus.byTime.development_product))
																? '个'
																: ''
														}}
													</div>
												</div>

												<div v-if="item.surplus.byTime.shopCnt">
													<div class="footer_title">店铺数量(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.shopCnt
														}}</span>
														{{ Boolean(Number(item.surplus.byTime.shopCnt)) ? '个' : '' }}
													</div>
												</div>
												<div v-if="item.surplus.byTime.employeeCnt">
													<div class="footer_title">员工数量(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.employeeCnt
														}}</span>
														{{
															Boolean(Number(item.surplus.byTime.employeeCnt)) ? '个' : ''
														}}
													</div>
												</div>
												<div v-if="item.surplus.byTime.listing">
													<div class="footer_title">刊登额度(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.listing
														}}</span>
														{{ Boolean(Number(item.surplus.byTime.listing)) ? '个' : '' }}
													</div>
												</div>
												<div v-if="item.surplus.byTime.imgStorage">
													<div class="footer_title">图片空间(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.imgStorage
														}}</span>
														<!-- {{ Boolean(Number(item.surplus.byTime.imgStorage)) ? 'M' : '' }} -->
													</div>
												</div>
												<div v-if="item.surplus.byTime.person_account">
													<div class="footer_title">子账号数量(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.person_account
														}}</span>
														{{
															Boolean(Number(item.surplus.byTime.person_account))
																? '个'
																: ''
														}}
													</div>
												</div>
												<div v-if="item.surplus.byTime.amz_operate_sell_monitor">
													<div class="footer_title">亚马逊跟卖监控(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.amz_operate_sell_monitor
														}}</span>
														{{
															Boolean(
																Number(item.surplus.byTime.amz_operate_sell_monitor)
															)
																? '个'
																: ''
														}}
													</div>
												</div>
												<div v-if="item.surplus.byTime.publish_nums">
													<div class="footer_title">刊登商品数(可用)</div>
													<div>
														<span class="footer_font">{{
															item.surplus.byTime.publish_nums
														}}</span>
														{{
															Boolean(Number(item.surplus.byTime.publish_nums))
																? '个'
																: ''
														}}
													</div>
												</div>
											</div>
											<div v-if="item.surplus.byTime.selection_product_monitor">
												<div class="footer_title fontWeight">产品监控：</div>
												<div class="footer">
													<div
														v-for="itemcheck in item.surplus.byTime
															.selection_product_monitor"
														:key="itemcheck.name"
													>
														<div class="footer_title">{{ itemcheck.name }}</div>
														<div>
															<span class="footer_font">{{ itemcheck.value }}</span>
															{{ Boolean(Number(itemcheck.value)) ? '个' : '' }}
														</div>
													</div>
												</div>
											</div>
											<div v-if="item.surplus.byTime.selection_shop_monitor">
												<div class="footer_title fontWeight">店铺监控：</div>
												<div class="footer">
													<div
														v-for="itemcheck in item.surplus.byTime.selection_shop_monitor"
														:key="itemcheck.name"
													>
														<div class="footer_title">{{ itemcheck.name }}</div>
														<div>
															<span class="footer_font">{{ itemcheck.value }}</span>
															{{ Boolean(Number(itemcheck.value)) ? '个' : '' }}
														</div>
													</div>
												</div>
											</div>
											<div v-if="item.surplus.byTime.selection_category_monitor">
												<div class="footer_title fontWeight">分类监控：</div>
												<div class="footer">
													<div
														v-for="itemcheck in item.surplus.byTime
															.selection_category_monitor"
														:key="itemcheck.name"
													>
														<div class="footer_title">{{ itemcheck.name }}</div>
														<div>
															<span class="footer_font">{{ itemcheck.value }}</span>
															{{ Boolean(Number(itemcheck.value)) ? '个' : '' }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</el-card>
							</el-tab-pane>
							<el-tab-pane label="服务器资源" name="1">
								<span>排序：</span>
								<el-select v-model="form.sort" @change="sortChange">
									<el-option label="根据有效期升序" value="expired_at,ASC"></el-option>
									<el-option label="根据有效期降序" value="expired_at,DESC"></el-option>
									<el-option label="根据续费日期升序" value="update_time,ASC"></el-option>
									<el-option label="根据续费日期降序" value="update_time,DESC"></el-option>
								</el-select>
								<div class="flex justify align-items-center mgb10">
									<!-- <el-dropdown @command="dropdownClick">
										<el-link type="primary" :underline="false">
											批量操作<i class="el-icon-arrow-down el-icon--right"></i>
										</el-link>
										<el-dropdown-menu slot="dropdown" :show-timeout="0">
											<el-dropdown-item command="0">批量续费</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown> -->
									<div class="flex" style="align-items: center">
										<input type="CheckBox" :checked="checkedAll" @click="handleCheckAll" />
										<span style="font-size: 14px">全选</span>
									</div>
									<el-button type="text" @click="batchRenew">批量续费</el-button>
								</div>
								<el-card
									style="margin: 10px 0 40px"
									:class="{ disable_status: item.status == 2 }"
									v-for="(item, idx) in serveResource"
									:key="idx"
								>
									<div class="flex-div flex-center">
										<input
											type="CheckBox"
											:disabled="item.status == 2"
											:checked="computedCheck(item)"
											@click="checked(item)"
										/>
										<div class="tables_center_icon"><i class="el-icon-suitcase-1"></i></div>
										<div class="tables_center_flex">
											<div class="fontWeight">
												{{ item.buyInfo.serverName ? item.buyInfo.serverName : '-' }}
											</div>
											<div class="tables_center_footer">
												<div class="footer_edition">
													<span>服务器ID：{{ item.ecsGid ? item.ecsGid : '-' }}</span>
													<span
														:class="{ 'error-color': item.status == 1 }"
														v-if="item.expired_at"
													>
														有效期至：{{ item.expired_at }}
													</span>
												</div>
												<div class="flex-div" v-if="item.status != 2">
													<div v-if="item.isShowServerManager" class="flex-div">
														<el-tooltip
															effect="dark"
															content="设置权限"
															placement="top-start"
														>
															<el-link
																style="font-size: 24px"
																type="primary"
																icon="el-icon-setting"
																@click="setPermission(item)"
															>
															</el-link>
														</el-tooltip>
														<el-tooltip
															effect="dark"
															content="修改配置"
															placement="top-start"
														>
															<el-link
																style="font-size: 24px; margin-left: 20px"
																type="primary"
																icon="el-icon-edit"
																@click="uploadCfg(item)"
															>
															</el-link>
														</el-tooltip>
													</div>
													<el-tooltip
														effect="dark"
														content="管理服务器"
														placement="top-start"
													>
														<el-link
															style="font-size: 24px; margin-left: 20px"
															type="primary"
															icon="el-icon-s-home"
															@click="controlUrls(item.controlUrl)"
														>
														</el-link>
													</el-tooltip>
													<el-tooltip
														effect="dark"
														content="续费服务器"
														placement="top-start"
													>
														<el-link
															style="font-size: 24px; margin-left: 20px"
															type="primary"
															icon="el-icon-sell"
															@click="renew(item)"
														>
														</el-link>
													</el-tooltip>
												</div>
												<div v-else class="footer_edition">已失效</div>
											</div>
										</div>
									</div>
								</el-card>
								<el-pagination
									class="page-float"
									@current-change="currentChange"
									:current-page.sync="form.page"
									:page-size="form.perpage"
									layout="total, prev, pager, next"
									:total="total"
								/>
							</el-tab-pane>
						</el-tabs>
					</div>
				</el-card>
			</el-col>
			<!-- 公告 -->
			<el-col :span="9">
				<el-card class="box-card">
					<div slot="header">
						<span class="box_title">公告</span>
					</div>
					<div class="announcement">
						<div>
							<!-- <div class="announcement_month">04月</div>
							<div class="announcement_day">12</div> -->
						</div>
						<div class="announcement_content">暂无公告</div>
					</div>
				</el-card>
			</el-col>
		</el-row>

		<el-dialog title="权限设置" :visible.sync="permissionDialog" width="30%" top="30vh">
			可见子帐号：
			<multi-select
				style="display: inline-block"
				:options="permissionAry"
				:selectedOptions.sync="permissionValAry"
				width="200"
				:hide="permission"
				value="employeeId"
				name="name"
				subTitle="mobile"
			></multi-select>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="permissionDialog = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submitPermission">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改配置" :visible.sync="configDialog" width="30%" top="30vh">
			<el-form label-position="left" label-width="130px" :model="cfgForm" @submit.native.prevent>
				<el-form-item label="带宽（M）：">
					<el-input-number
						v-model="cfgForm.width"
						@change="changeSlider"
						:min="cfgForm.minWidth"
						:max="200"
						size="mini"
					></el-input-number>
				</el-form-item>
				<el-form-item label="价格（元）：" class="primart-active-color">
					{{ cfgForm.price }}
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="configDialog = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submitConfig">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="续费" :visible.sync="renewDialog" width="30%" top="30vh">
			<el-form label-position="left" label-width="130px" :model="cfgForm" @submit.native.prevent>
				<el-form-item label="付费方式：">
					<el-select v-model="payWay" size="small" @change="changePayWay" placeholder="请选择付费方式">
						<el-option v-for="item in payWayAry" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="续费时长：" class="primart-active-color">
					<el-select v-model="period" size="small" @change="changeRenewTime" placeholder="请选择时长">
						<el-option v-for="item in timeAry" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="续费价格（元）：" class="primart-active-color">
					{{ renewPriceVal }}
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="renewDialog = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submitRenew">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="批量续费" :visible.sync="batchRenewDialog" top="13vh">
			<el-form label-position="left" label-width="100px" @submit.native.prevent>
				<el-form-item label="付费方式：">
					<el-select
						v-model="batchPayWay"
						size="small"
						@change="changeBatchPayWay"
						placeholder="请选择付费方式"
					>
						<el-option v-for="item in payWayAry" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="续费时长：" class="primart-active-color">
					<el-select v-model="batchPeriod" size="small" @change="changeBatchPeriod" placeholder="请选择时长">
						<el-option v-for="item in timeAry" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<!-- @selection-change="checkService" -->
			<el-table :data="batchRenewData" height="35vh" style="width: 100%">
				<!-- <el-table-column type="selection" width="45" align="center"></el-table-column> -->
				<el-table-column prop="ecsGid" label="服务器ID"></el-table-column>
				<el-table-column prop="name" label="主机名"></el-table-column>
				<el-table-column prop="expired_at" label="有效期"></el-table-column>
				<el-table-column prop="update_time" label="续费日期"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="{ $index }">
						<el-button type="text" :disabled="batchRenewData.length === 1" @click="removeRenew($index)"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<div class="flex-div mgt10" style="justify-content: space-between">
				<span>
					价格（元）：
					<span class="primart-active-color">{{ batchTotalPrice }}</span>
				</span>
				<!-- <el-pagination
					@current-change="currentChange"
					:current-page.sync="currentPage"
					:page-size="currentSize"
					layout="total, prev, pager, next"
					:total="total"
				>
				</el-pagination> -->
			</div>
			<div class="text-right mgt10">
				<el-button size="small" @click="batchRenewDialog = false">取消</el-button>
				<el-button size="small" type="primary" @click="createBatchRenewOrder">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	userInfo,
	resource,
	emloyeeList,
	setServerOption,
	publicipOrder,
	publicipPrice,
	renewPrice,
	createRenewOrder,
	getServeResource,
	getRenewBatchPrice,
	createRenewBatch,
} from '@/utils/api'
import constant from '../../../utils/constant'
import MultiSelect from '../../../components/MultiSelect'

export default {
	components: {
		MultiSelect,
	},
	data() {
		return {
			// 勾选数组
			batchRenewData: [],
			form: {
				page: 1,
				perpage: 30,
				sort: 'expired_at,ASC',
				orderBy: 'create_time',
				isAsc: 1,
			},
			checkedAll: false,
			eye: true, //显示与隐藏
			circleUrl: 'first',
			userInfo: {
				amount: 0, //余额
				orders: 0, //订单数
				coupons: 0, //优惠券数
				expires: 0, //即将到期资源数
				welcomeDesc: '', //欢迎语
				company: '', //公司名称
				lastIp: '', //登录IP
				lastTime: '', //上次登录时间
				childAccountNum: 0, //子账号数
				roleNum: 0, //角色
				face: '', //用户头像
			},
			resource: [], //资源
			pathUrl: [
				{
					id: constant.MODULES_OBJ.plateformId,
					url: '/yingyong/platform',
				},
				{
					id: constant.MODULES_OBJ.toolId,
					url: '/yingyong/tool',
				},
				{
					id: constant.MODULES_OBJ.serve,
					url: '/yingyong/serve',
				},
				{
					id: constant.MODULES_OBJ.purchased,
					url: '/yingyong/purchased',
				},
				{
					id: constant.MODULES_OBJ.cloud,
					url: '/yingyong/cloudservices',
				},
			],
			flag: false,
			permissionDialog: false,
			permissionValAry: [],
			permissionAry: [],
			permission: false,
			configDialog: false,
			orderObj: null,
			cfgForm: {
				width: 2,
				price: 0,
				minWidth: 1,
			},
			renewDialog: false,
			payWayAry: [
				{
					label: '包月',
					value: 'month',
				},
				{
					label: '包年',
					value: 'year',
				},
			],
			payWay: 'month',
			period: '',
			timeAry: [],
			month: [
				{ value: 1, label: '1个月' },
				{ value: 2, label: '2个月' },
				{ value: 3, label: '3个月' },
				{ value: 6, label: '6个月' },
			],
			year: [
				{ value: 1, label: '1年' },
				{ value: 2, label: '2年' },
				{ value: 3, label: '3年' },
			],
			renewPriceVal: 0,
			serveResource: [],
			ecsGid: '',
			serverId: -1,
			batchRenewDialog: false,
			batchRenewTabData: [],
			currentPage: 1,
			total: 0,
			currentSize: 30,
			batchTotalPrice: 0,
			batchPayWay: 'month',
			batchPeriod: '',
			escIdAry: [],
		}
	},
	mounted() {
		if (sessionStorage.getItem('sourceInfo')) {
			if (JSON.parse(sessionStorage.getItem('sourceInfo')).projectId == constant.PROJECT_ID_DEV) this.flag = false
			else this.flag = true
		} else {
			let id = this.$route.query.ProjectId ? this.$route.query.ProjectId : this.$route.query.projectId
			if (id == constant.PROJECT_ID_DEV) this.flag = false
			else this.flag = true
		}
		this.getuserInfo()
		this.getPlateFormRes()
	},
	methods: {
		sortChange(val) {
			const arr = val.split(',')
			this.form.page = 1
			this.form.orderBy = arr[0]
			this.form.isAsc = Number(arr[1] === 'ASC')
			this.getServeRes()
		},
		handleClick(item) {
			if (item.index == 1) {
				// 服务器资源
				this.getServeRes()
			} else {
				// 平台资源
				this.getPlateFormRes()
			}
		},
		getServeRes() {
			this.serveResource = []
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
				...this.form,
			}
			getServeResource(params).then((res) => {
				res.res_array.forEach((item) => {
					item.status = this.getStatus(item.expired_at, Number(res.config.expire_date))
					this.serveResource.push({ ...item })
				})
				this.total = res.total
			})
		},
		getStatus(date, day) {
			/**
			 * 返回说明
			 * 0: 正常
			 * 1：快过期
			 * 2：过期
			 */
			if (!date) return 0
			if (!day) day = 0
			let nowDate = new Date()
			let returnDate = new Date(date)
			let futureDate = returnDate.getTime() - day * 3600 * 24 * 1000
			futureDate = new Date(futureDate)
			if (nowDate.getTime() > returnDate.getTime()) {
				return 2
			} else if (nowDate.getTime() > futureDate.getTime()) {
				return 1
			} else {
				return 0
			}
		},
		getPlateFormRes() {
			this.resource = []
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			resource(params).then((res) => {
				if (res.notExpire) {
					res.notExpire.forEach((item) => {
						if (item.surplus.byTime.selection_product_monitor) {
							let arr = []
							for (let key in item.surplus.byTime.selection_product_monitor) {
								arr.push({ name: key, value: item.surplus.byTime.selection_product_monitor[key] })
							}
							item.surplus.byTime.selection_product_monitor = arr
						}
						if (item.surplus.byTime.selection_shop_monitor) {
							let arr = []
							for (let key in item.surplus.byTime.selection_shop_monitor) {
								arr.push({ name: key, value: item.surplus.byTime.selection_shop_monitor[key] })
							}
							item.surplus.byTime.selection_shop_monitor = arr
						}
						if (item.surplus.byTime.selection_category_monitor) {
							let arr = []
							for (let key in item.surplus.byTime.selection_category_monitor) {
								arr.push({ name: key, value: item.surplus.byTime.selection_category_monitor[key] })
							}
							item.surplus.byTime.selection_category_monitor = arr
						}
					})
					this.resource = [...res.notExpire]
				}
				if (res.expire) {
					res.expire.forEach((e) => {
						e.mbStatus = true
						this.resource.push(e)
					})
				}
			})
		},
		//充值
		recharge() {
			this.$router.push('/rechargepay')
		},
		//获取用户信息
		getuserInfo() {
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			userInfo(params).then((res) => {
				this.userInfo = { ...res }
			})
		},
		//订单数跳转
		orderTo(val) {
			if (this.eye && this.userInfo.orders && val == 1) {
				this.$router.push('/order/orderlist')
			}
			if (this.eye && this.userInfo.coupons && val == 2) {
				this.$router.push('/coupons')
			}
		},
		// 物流账单
		LogisticsOrderTo() {
			this.$router.push('/logistics-order')
		},
		//服务器管理地址跳转
		controlUrls(url) {
			window.open(url)
		},
		//加购与续费
		toProduct(moduleId, editionId) {
			let arr = this.pathUrl.filter((item) => item.id == moduleId)
			this.$router.push({
				path: arr[0].url,
				query: {
					editionId: editionId,
				},
			})
		},
		setPermission(item) {
			this.serverId = item.id
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
				id: item.id,
			}
			emloyeeList(params).then((res) => {
				this.permissionAry = res.data
				this.permissionValAry = []
				if (res.config.length > 0) {
					res.config.forEach((cfg) => {
						let filterAry = res.data.filter((res) => {
							return res.employeeId == cfg
						})
						this.permissionValAry.push(filterAry[0])
					})
				}
			})
			this.permissionDialog = true
		},
		submitPermission() {
			let ids = []
			this.permissionValAry.forEach((item) => {
				ids.push(item.employeeId)
			})
			let data = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
				employeeIds: ids,
				id: this.serverId,
			}
			setServerOption(data).then(() => {
				this.$message.success('设置成功！')
				this.permissionDialog = false
			})
		},
		uploadCfg(item) {
			this.ecsGid = item.ecsGid
			if (item.buyInfo) {
				let width = item.buyInfo.internetBandWidth + 1
				this.$set(this.cfgForm, 'width', width)
				this.$set(this.cfgForm, 'minWidth', width)
			}
			this.getPrice()
			this.configDialog = true
		},
		submitConfig() {
			let params = {
				ecsGid: this.ecsGid,
				width: this.cfgForm.width,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			publicipOrder(params).then((res) => {
				this.$router.push({
					path: '/pay',
					query: {
						orderNo: res.orderNo,
						moduleId: null,
					},
				})
			})
		},
		changeSlider() {
			this.getPrice()
		},
		getPrice() {
			let params = {
				ecsGid: this.ecsGid,
				width: this.cfgForm.width,
			}
			publicipPrice(params).then((res) => {
				let price = res.discountPrice <= 0 ? 0 : res.discountPrice
				this.$set(this.cfgForm, 'price', price)
			})
		},
		renew(item) {
			try {
				this.ecsGid = item.ecsGid
				this.payWay = item.buyInfo.payMethod
				this.timeAry = this[this.payWay]
				this.period = this.timeAry[0].value
			} catch (error) {
				console.log(error)
			}
			this.getRenewPrice(true)
		},
		changePayWay(item) {
			this.timeAry = this[item]
			this.period = this.timeAry[0].value
			this.getRenewPrice()
		},
		changeRenewTime() {
			this.getRenewPrice()
		},
		getRenewPrice(isFirst = false) {
			let params = {
				ecsGid: this.ecsGid,
				period: this.period,
				type: this.payWay,
			}
			renewPrice(params).then((res) => {
				if (isFirst) {
					this.renewDialog = true
				}
				console.log(res)
				this.renewPriceVal = res.price
			})
		},
		submitRenew() {
			let params = {
				ecsGid: this.ecsGid,
				period: this.period,
				type: this.payWay,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			createRenewOrder(params).then((res) => {
				this.$router.push({
					path: '/pay',
					query: {
						orderNo: res.orderNo,
					},
				})
			})
		},
		// 批量续费
		batchPrice() {
			this.timeAry = this[this.batchPayWay]
			this.batchPeriod = this.timeAry[0].value
			// let start = (this.currentPage - 1) * this.currentSize
			// this.batchRenewTabData = this.serveResource.slice(start, start + this.currentSize)
			this.batchRenewDialog = true
			this.$nextTick(() => {
				this.checkService(this.batchRenewData)
			})
		},
		// 批量操作
		dropdownClick(idx) {
			if (idx == 0) this.batchPrice()
		},
		currentChange() {
			// let start = (this.currentPage - 1) * this.currentSize
			// this.batchRenewTabData = this.serveResource.slice(start, start + this.currentSize)
			// this.form.page = 1
			this.getServeRes()
		},
		checkService(selection) {
			this.escIdAry = []
			selection.forEach((item) => {
				this.escIdAry.push({
					gid: item.ecsGid,
				})
			})
			this.getBatchPrice()
		},
		// 获取批量创建价格
		getBatchPrice() {
			let data = {
				period: this.batchPeriod,
				type: this.batchPayWay,
				ecsIds: this.escIdAry,
			}
			getRenewBatchPrice(data).then((res) => {
				this.batchTotalPrice = res.totalPrice
			})
		},
		changeBatchPayWay(type) {
			this.batchPayWay = type
			this.timeAry = this[type]
			if (this.escIdAry.length > 0) {
				this.getBatchPrice()
			}
		},
		changeBatchPeriod() {
			if (this.escIdAry.length > 0) {
				this.getBatchPrice()
			}
		},
		//批量创建订单
		createBatchRenewOrder() {
			let data = {
				period: this.batchPeriod,
				type: this.batchPayWay,
				ecsIds: this.escIdAry,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			createRenewBatch(data).then((res) => {
				this.$router.push({
					path: '/pay',
					query: {
						orderNo: res.orderNo,
					},
				})
			})
		},
		// 计算是否被选中
		computedCheck(item) {
			const index = this.batchRenewData.findIndex((el) => el.id === item.id)
			return index > -1
		},
		// 全选或者取消全选
		handleCheckAll() {
			this.checkedAll = !this.checkedAll
			if (this.checkedAll) {
				this.batchRenewData = this.serveResource.filter((el) => +el.status !== 2)
			} else {
				this.batchRenewData = []
			}
		},
		// 勾选或者取消勾选项
		checked(item) {
			const index = this.batchRenewData.findIndex((el) => el.id === item.id)
			if (index > -1) {
				this.batchRenewData.splice(index, 1)
			} else {
				this.batchRenewData.push(item)
			}
		},
		// 新批量续费
		batchRenew() {
			if (this.batchRenewData.length < 1) {
				this.$message.error('请勾选需要批量续费的服务器！')
				return
			}
			this.batchPrice()
		},
		// 删除续费项
		removeRenew(index) {
			this.batchRenewData.splice(index, 1)
			this.checkService(this.batchRenewData)
		},
	},
}
</script>

<style scoped>
.el-link.el-link--default:after,
.el-link.el-link--primary.is-underline:hover:after,
.el-link.el-link--primary:after {
	border-color: #003366;
}
.box >>> .el-tabs__active-bar {
	background-color: #003366;
}
.box >>> .el-tabs__item:hover,
.box >>> .el-tabs__item.is-active {
	color: #003366;
}
.wap_color {
	color: #003366;
}
.box-title {
	font-size: 14px;
	margin-bottom: 20px;
	padding-left: 4px;
	/* font-style: italic; */
}
.ele {
	cursor: pointer;
	width: 20px;
}
.ele img {
	margin-left: 10px;
	display: block;
	width: 100%;
}
.icon {
	margin-left: 10px;
	cursor: pointer;
	font-size: 16px;
}
.box_title {
	font-size: 16px;
	font-weight: bold;
}
.body_title {
	font-size: 14px;
	margin-bottom: 23px;
}
.body_title_center .font {
	font-size: 20px;
}
.recharge {
	padding: 0 20px;
	height: 28px;
	background: #003366;
	color: #ffffff;
	line-height: 28px;
	text-align: center;
	cursor: pointer;
	margin-left: 25px;
	font-size: 12px;
	border-radius: 5px;
}
.flex {
	display: flex;
}
.align-items-center {
	align-items: center;
}

.justify {
	justify-content: space-between;
}
.recharge1 {
	width: 57px;
	height: 28px;
	line-height: 28px;
	text-align: center;
	cursor: pointer;
	border: 1px solid #ccc;
	box-sizing: border-box;
	margin-left: 25px;
	font-size: 12px;

	border-radius: 5px;
}
.footer {
	display: flex;
	margin-top: 15px;
	text-align: left;
	flex-wrap: wrap;
}
.footer > div {
	flex: 1;
	margin-bottom: 20px;
}
.footer_title {
	margin-bottom: 10px;
}
.footer_font {
	font-size: 20px;
}
.red {
	color: red;
}
.block {
	display: flex;
	padding-bottom: 30px;
}
.block_name {
	height: 22px;
	line-height: 22px;
	font-size: 16px;
	font-weight: bold;
}
.block_IP {
	margin: 10px 0;
	font-size: 12px;
	color: #797979;
}
.block_footer {
	display: flex;
	justify-content: space-around;
	text-align: center;
	padding-bottom: 69px;
}
::v-deep .el-tabs__nav-wrap::after {
	width: 0px;
}
.tables_center_flex {
	flex: 1;
}
.tables_center {
	display: flex;
	padding-bottom: 10px;
}
.tables_center_icon {
	margin-right: 20px;
	font-size: 30px;
}
.tables_center_footer {
	display: flex;
	justify-content: space-between;
}
.footer_edition {
	font-size: 12px;
	margin-top: 13px;
}
.footer_edition span:first-child {
	margin-right: 100px;
}
.tables_footer {
	border-top: 1px solid #ccc;
}
.tables_footer_font {
	font-size: 13px;
	color: #ccd;
	margin-top: 20px;
}
.announcement {
	display: flex;
	font-size: 14px;
}
.announcement > div:first-child {
	margin-right: 5px;
}
.announcement_month {
	width: 32px;
	padding: 4px;
	background: #f2f6fc;
	color: #8b9db6;
	margin-bottom: 2px;
}
.announcement_day {
	font-size: 18px;
	padding: 4px;
	background: #f2f6fc;
	color: #8b9db6;
	text-align: center;
}
.announcement_content {
	padding: 4px;
	height: 16px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.footers {
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
	text-align: center;
}
.resdiv {
	margin-bottom: 40px;
	box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
	padding: 20px 20px 10px;
}
.disable_status {
	color: #ccc;
}
.flex-center {
	align-items: center;
}
.page-float {
	float: right;
	margin-top: 10px;
}
</style>
